const baseCSS = {
  "html, body": {
    fontFamily: `Pretendard,  -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji',
    'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'`,
    "-webkit-font-smoothing": "antialiased",
    "-moz-osx-font-smoothing": "auto",
    lineHeight: 1,
    fontSize: "14px",
    margin: 0,
    padding: 0,
    fontWeight: 500
  },
  "*": { boxSizing: "border-box" },
  'a, area, button, [role="button"], input:not([type="range"]), label, select, summary, textarea': {
    outline: "none"
  },
  '[role="button"]': {
    background: "none"
  },
  "input, button,select, optgroup, textarea": {
    margin: "0",
    padding: "0",
    border: "none",
    color: "inherit",
    fontSize: "inherit",
    fontFamily: "inherit",
    lineHeight: "inherit"
  },
  'button, html [type="button"],[type="reset"], [type="submit"]': {
    "-webkit-appearance": "none"
  },
  p: {
    marginTop: 0,
    marginBottom: 0
  },
  "h1, h2, h3, h4, h5, h6": {
    margin: 0,
    padding: 0
  },
  "input, textarea": {
    "-webkit-appearance": "none",
    appearance: "none"
  },
  'input[type="search"]': {
    "-webkit-appearance": "none"
  },
  "ul, ol": {
    listStyle: "none",
    paddingInlineStart: 0
  }
};

export { baseCSS };
//# sourceMappingURL=baseCSS.mjs.map
